import './view-event-form.scss';
import { BookedStatusEnum, Event } from '../../../../store/events/eventTypes';
import EventFormInfo from '../../../pages/book-events/BookEventForm/EventFormInfo';
import ShowPolicyButton from '../../../pages/book-events/BookEventForm/ShowPolicyButton';
import BookEventFormGuests from '../../../pages/book-events/BookEventForm/BookEventFormGuests';
import ViewEventFormActions from '../../../pages/book-events/BookEventForm/ViewEventFormActions';
import { getTimeStringFromTimestamp } from '../../../../utility/functions/getTimeStringFromTimestamp';

type PropsTypes = {
  title: string;
  event: Event;
  onSwitchShowPolicy: () => void;
  onCancelEvent: () => void;
  showPolicy: boolean;
  closeModal: () => void;
};

const ViewEventForm = ({
  title,
  event,
  onSwitchShowPolicy,
  showPolicy,
  onCancelEvent,
  closeModal,
}: PropsTypes) => {
  return (
    <div className="book-event-form">
      <div className="book-event-form-content">
        <EventFormInfo
          title={title}
          price={event.price}
          date={new Date(event.fromDate).toDateString()}
          time={getTimeStringFromTimestamp(+event.fromDate)}
          placesLeft={event.capacity - event.participants.length}
          capacity={event.capacity}
          locationName={event.resource.building.location?.name}
          buildingName={event.resource.building.name}
          floorNumber={event.resource.floor ? event.resource.floor?.number : ''}
        />
        <BookEventFormGuests participants={event.participants} />
      </div>
      <ViewEventFormActions
        onCancelEvent={onCancelEvent}
        onCloseModal={closeModal}
        isWaitingList={event.bookedStatus === BookedStatusEnum.IN_WAIT_LIST}
      />
      <ShowPolicyButton
        showPolicy={showPolicy}
        onSwitchShowPolicy={onSwitchShowPolicy}
      />
    </div>
  );
};

export default ViewEventForm;
